import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import Products from "./components/Products";
import ContactUs from "./components/ContactUs";
import Faqs from "./components/Faqs";
import DogsNutritionSupplement from "./components/DogsNutritionSupplement";
import PuffNuggets from "./components/PuffNuggets";
import ChewBarFlavours from "./components/ChewBarFlavours";
import DogsChewBar from "./components/DogsChewBar";
import Blogs from "./components/Blogs";

// Import your page components here

const AppRoute = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/products" element={<Products />}></Route>
    <Route
      path="/products/dogs-nutrition-supplement"
      element={<DogsNutritionSupplement />}
    />
    <Route
      path="/products/puff-nuggets-for-pets"
      element={<PuffNuggets />}
    />
    <Route
      path="/products/chew-bar-flavours"
      element={<ChewBarFlavours />}
    />
    <Route
      path="/products/dogs-chew-bar"
      element={<DogsChewBar />}
    />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/faqs" element={<Faqs />} />
    <Route path="/blogs" element={<Blogs />} />
    <Route path="*" element={<HomePage />} />
  </Routes>
);

export default AppRoute;
